import { render } from "./HeaderNotification.vue?vue&type=template&id=b44471ee"
import script from "./HeaderNotification.vue?vue&type=script&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
